import { NavLink } from "react-router-dom";
import Breadcumbs from "../components/Breadcumbs";
import BlockRightImage from "../components/BlockRightImage";
import Accordion from "../components/Accordion";
import DataFetcherTemplate from "../hooks/fetchTemplate";
import Block3Columns from "../components/Block3Columns";
import { motion } from "framer-motion";
import {
  DistanciaContinuos,
  PresencialInscripcion,
  PresencialNuevos,
  PresencialContinuos,
  PosgradoPostulacion,
  PosgradoNuevos,
  DistanciaNuevos,
} from "../components/Pasos";
import BannerGeneral from "../components/BannerGeneral";
import EnLineaPagos from "../components/Enlineapagos";
import PosgradoPagos from "../components/PosgradoPagos";
import PresencialPagos from "../components/PresencialPagos";
import TecPagos from "../components/TecPagos";
import { ChevronDown, Laptop, GraduationCap, Briefcase } from "lucide-react";
function Matriculas() {
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div className="wrapper-matricula">
            {data.map((item, index) => (
              <div key={index}>
                <div className="layout6">
                  <center>
                    <h2>
                      <b> ¡Matricúlate ahora</b> y descubre todo lo que
                      necesitas saber sobre los enlaces de registro, fechas,
                      procesos y calendario académico adaptado a tu programa de
                      estudios!
                    </h2>
                    <p>
                      Ya seas un estudiante nuevo o de segundo ciclo en
                      adelante, aquí encontrarás todo lo necesario para
                      planificar tu periodo académico.
                    </p>
                  </center>
                </div>

                <div className="layout6">
                  <center>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_texto_portada,
                      }}
                    />{" "}
                  </center>
                </div>

                <div className="py-8 pb-12">
                  <div className=" max-w-6xl mx-auto ">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                      {/* CARD 1 */}
                      <a
                        href="#enlinea"
                        className="group relative flex flex-col items-center text-center 
      bg-white border border-gray-200 
      rounded-2xl p-6 
      shadow-sm hover:shadow-xl 
      transition-all duration-300 hover:-translate-y-2"
                      >
                        {/* ICONO */}
                        <div
                          className="w-14 h-14 flex items-center justify-center rounded-xl 
      bg-blue-50 text-blue-600 mb-4 
      transition-all duration-300 group-hover:scale-110"
                        >
                          <Laptop className="w-7 h-7" />
                        </div>

                        {/* TEXTO */}
                        <h4 className="text-[#004270] font-semibold leading-snug group-hover:text-gray-900">
                          Carreras a distancia y en línea, carreras tecnológicas
                        </h4>

                        {/* FLECHA */}
                        <motion.div
                          className="absolute bottom-3"
                          animate={{ y: [0, 6, 0] }}
                          transition={{ duration: 1.2, repeat: Infinity }}
                        >
                          <ChevronDown className="w-6 h-6 text-gray-400 group-hover:text-gray-700" />
                        </motion.div>
                      </a>

                      {/* CARD 2 */}
                      <a
                        href="#presencial"
                        className="group relative flex flex-col items-center text-center 
      bg-white border border-gray-200 
      rounded-2xl p-6 
      shadow-sm hover:shadow-xl 
      transition-all duration-300 hover:-translate-y-2"
                      >
                        <div
                          className="w-14 h-14 flex items-center justify-center rounded-xl 
      bg-yellow-50 text-yellow-600 mb-4 
      transition-all duration-300 group-hover:scale-110"
                        >
                          <GraduationCap className="w-7 h-7" />
                        </div>

                        <h4 className="text-[#004270] font-semibold leading-snug group-hover:text-gray-900">
                          Carreras presencial
                        </h4>

                        <motion.div
                          className="absolute bottom-3"
                          animate={{ y: [0, 6, 0] }}
                          transition={{ duration: 1.2, repeat: Infinity }}
                        >
                          <ChevronDown className="w-6 h-6 text-gray-400 group-hover:text-gray-700" />
                        </motion.div>
                      </a>

                      {/* CARD 3 */}
                      <a
                        href="#posgrados"
                        className="group relative flex flex-col items-center text-center 
      bg-white border border-gray-200 
      rounded-2xl p-6 
      shadow-sm hover:shadow-xl 
      transition-all duration-300 hover:-translate-y-2"
                      >
                        <div
                          className="w-14 h-14 flex items-center justify-center rounded-xl 
      bg-indigo-50 text-indigo-600 mb-4 
      transition-all duration-300 group-hover:scale-110"
                        >
                          <Briefcase className="w-7 h-7" />
                        </div>

                        <h4 className="text-[#004270] font-semibold leading-snug group-hover:text-gray-900">
                          Posgrados
                        </h4>

                        <motion.div
                          className="absolute bottom-3"
                          animate={{ y: [0, 6, 0] }}
                          transition={{ duration: 1.2, repeat: Infinity }}
                        >
                          <ChevronDown className="w-6 h-6 text-gray-400 group-hover:text-gray-700" />
                        </motion.div>
                      </a>
                    </div>
                  </div>
                </div>
                <div id="enlinea">
                  <BlockRightImage
                    src={item.field_imagen1}
                    alt="utpl"
                    content={
                      <>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque1,
                          }}
                        />{" "}
                        <div>
                          <Accordion
                            title="Fechas de matrícula"
                            content={
                              <>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.field_bloque2,
                                  }}
                                />
                              </>
                            }
                          ></Accordion>

                          <Accordion
                            title="Calendario académico"
                            content={
                              <>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.field_bloque3,
                                  }}
                                />
                              </>
                            }
                          ></Accordion>
                        </div>
                        <br></br>
                        <DistanciaNuevos></DistanciaNuevos>
                        <DistanciaContinuos></DistanciaContinuos>
                      </>
                    }
                  ></BlockRightImage>
                  <div className="padding2">
                    <center>
                      {" "}
                      <h3>Descuentos para carreras en línea</h3>
                    </center>
                    <EnLineaPagos></EnLineaPagos>{" "}
                  </div>{" "}
                  <div>
                    <center>
                      {" "}
                      <h3>Descuentos para carreras tecnológicas</h3>
                    </center>
                    <TecPagos></TecPagos>{" "}
                  </div>
                </div>
                <div className="lightbluebg " id="presencial">
                  <div>
                    <BlockRightImage
                      src={item.field_imagen4}
                      alt="utpl"
                      content={
                        <>
                          {" "}
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.field_bloque4,
                            }}
                          />{" "}
                          <div>
                            <Accordion
                              title="Fechas de matrícula"
                              content={
                                <>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item.field_bloque5,
                                    }}
                                  />
                                </>
                              }
                            ></Accordion>
                            <Accordion
                              title="Calendario académico"
                              content={
                                <>
                                  {" "}
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item.field_bloque6,
                                    }}
                                  />
                                </>
                              }
                            ></Accordion>
                          </div>
                          <a
                            href="https://utpl.edu.ec/documentos/manual_presencial.pdf"
                            className="link-with-arrow"
                          >
                            Revisa el proceso de inscripción y matrícula para
                            estudiantes nuevos
                          </a>
                    
                          <PresencialContinuos></PresencialContinuos>
                        </>
                      }
                    ></BlockRightImage>
                    <div className="padding2">
                      <PresencialPagos></PresencialPagos>
                    </div>
                  </div>
                </div>
                <div id="posgrados">
                  <div>
                    <BlockRightImage
                      src={item.field_imagen7}
                      alt="utpl"
                      content={
                        <>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.field_bloque7,
                            }}
                          />{" "}
                          <div>
                            <Accordion
                              title="Fechas de matrícula"
                              content={
                                <>
                                  {" "}
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item.field_bloque8,
                                    }}
                                  />
                                </>
                              }
                            ></Accordion>
                            <Accordion
                              title="Calendario académico"
                              content={
                                <>
                                  {" "}
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item.field_bloque9,
                                    }}
                                  />
                                </>
                              }
                            ></Accordion>
                          </div>
                          <PosgradoPostulacion></PosgradoPostulacion>
                          <PosgradoNuevos></PosgradoNuevos>
                        </>
                      }
                    ></BlockRightImage>
                  </div>

                  <div className="padding2">
                    <PosgradoPagos></PosgradoPagos>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <div className="margin">
        <Breadcumbs
          content={
            <>
              <NavLink to="/matriculas">Matrículas</NavLink>
            </>
          }
        ></Breadcumbs>
      </div>

      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/services/servicio-matriculas.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default Matriculas;
